export const localizationsCode = {
  CZ: 'cs_CZ',
  EN: 'en_US',
};
